/**
 * Created by Rodrigo Quesada on 09/03/17.
 */
import {NgModule} from '@angular/core';
import {FileListComponent} from './file-list.component';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [FileListComponent],
    exports: [FileListComponent]
})
export class FileListModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/file-list/file-list.module.ts